
export default {

	//data
	data() {

	},

	//methods
	methods: {

	},

	//watch
	watch: {

	},

	//created
	created() {
		console.log("validacion isr notificacion");
		// obtener parametros de la url "incriptado"
		let encriptado = this.$route.params.data_encriptada;
		console.log(encriptado);
	},

	//destroyed
	destroyed() {

	},

	//components
	components: {

	}

}